/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Forma della proroga di scadenza dei voucher
 */
export enum FormaProrogaVoucher {

    GIORNI = 'GIORNI',

    DATA = 'DATA'
}

